import { sample } from 'effector';
import { handleRouteChangeFx } from 'model/helpers/analytics.model';
import { RootDomain } from 'model/root.model';

export enum ScreenName {
	welcome_desktop = 'welcome_desktop',
	welcome_mobile = 'welcome_mobile',
	welcome_handoff = 'welcome_handoff',
	qr = 'qr',
	link = 'link',
	link_success = 'link_success',
	email = 'email',
	email_success = 'email_success',
	email_error = 'email_error',
	sms = 'sms',
	sms_success = 'sms_success',
	sms_error = 'sms_error',
	mobile_connected = 'mobile_connected',
	camera_permissions_requested = 'camera_permissions_requested',
	camera_permissions_rejected = 'camera_permissions_rejected',
	doc_front_instructions = 'doc_front_instructions',
	doc_front_feedback = 'doc_front_feedback',
	doc_back_instructions = 'doc_back_instructions',
	doc_back_feedback = 'doc_back_feedback',
	selfie_instructions = 'selfie_instructions',
	selfie_feedback = 'selfie_feedback',
	flow_completed = 'flow_completed',
	invalid_session_desktop = 'invalid_session_desktop',
	invalid_session_mobile = 'invalid_session_mobile',
	invalid_device = 'invalid_device',
	error_desktop = 'error_desktop',
	error_mobile = 'error_mobile',
}

export const screenHistoryPush = RootDomain.event<ScreenName>();

export const screensHistory$ = RootDomain.store<ScreenName[]>([]);
export const lastScreen$ = screensHistory$.map(history => history[history.length - 1]);

screensHistory$
	.on(screenHistoryPush, (history, screenName) => [...history, screenName]);

sample({
	source: { history: screensHistory$ },
	clock: screenHistoryPush,
	fn: (source, clock) => ({
		from: source.history[source.history.length - 2] || null,
		route: clock,
	}),
	target: handleRouteChangeFx,
});
